// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleListuserApiCall } from "../../Api/api";

// Define an initial state for the slice
const initialState = {
   user: null,
   total: 0,
   loading: false,
   error: null,
};

// Create an async thunk for the login action
export const listUserAsync = createAsyncThunk(
   "auth/view/list-user",
   async ({ params, done, err } = {}, thunkAPI) => {
      try {
         const { data: response } = await handleListuserApiCall(params);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here

         err && err(error?.message || error);
         return thunkAPI.rejectWithValue(error);
      }
   },
);

// Create a slice of the Redux store
const listUserSlice = createSlice({
   name: "auth",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(listUserAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(listUserAsync.fulfilled, (state, action) => {
            state.loading = false;
            const rawList = Array.isArray(action.payload?.res)
               ? action.payload.res
               : Array.isArray(action.payload?.res?.data)
                 ? action.payload.res.data
                 : Array.isArray(action.payload?.data)
                   ? action.payload.data
                   : [];
            state.user = rawList;
            state.pagination = action.payload?.pagination || null;
            state.total =
               action.payload?.pagination?.total
         })
         .addCase(listUserAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});

// Export the reducer
export default listUserSlice.reducer;
